// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codeInputContainer {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    margin-bottom: 52px;
}

.codeInputBox {
    width: 36px;
    height: 55px;
    background: none;
    border: 2px #8E3B00 solid;
    border-radius: 8px;
    font-size: 18px;
    text-align: center;
    outline: none;
}

.codeInputDivider {
    width: 12px;
    background-color: transparent;
    display: inline-block;
    border-bottom: 3px #8E3B00 solid;
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/RestorePassword/CodeInput.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;AACvB","sourcesContent":[".codeInputContainer {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 52px;\n}\n\n.codeInputBox {\n    width: 36px;\n    height: 55px;\n    background: none;\n    border: 2px #8E3B00 solid;\n    border-radius: 8px;\n    font-size: 18px;\n    text-align: center;\n    outline: none;\n}\n\n.codeInputDivider {\n    width: 12px;\n    background-color: transparent;\n    display: inline-block;\n    border-bottom: 3px #8E3B00 solid;\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
